import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from './ErrorMessage';
import classNames from 'classnames';
import { normalizePortalText } from 'utils/baochauTheme';
import useFormControl from './useFormControl';
import './style.scss';

const FormInput = ({
  field,
  validation,
  type = 'text',
  placeholder,
  className,
  disabled,
  readOnly,
  bordered,
  onChange,
  id,
  'aria-describedby': ariaDescribedBy,
  ...props
}) => {
  const {
    describedBy,
    error,
    errorId,
    errorMessage,
    fieldValue,
    hasError,
    inputId,
    isFlashing,
    setFieldValue,
  } = useFormControl({ field, validation, id, ariaDescribedBy });
  const isChoiceControl = type === 'checkbox' || type === 'radio';

  const handleChange = (e) => {
    const value = isChoiceControl ? (e.target.checked ? 1 : 0) : e.target.value;
    setFieldValue(value);
    onChange?.(e, value);
  };

  const valueProps = isChoiceControl ? { checked: Boolean(fieldValue) } : { value: fieldValue ?? '' };

  return (
    <React.Fragment>
      <input
        id={inputId}
        type={type}
        placeholder={typeof placeholder === 'string' ? normalizePortalText(placeholder) : placeholder}
        className={classNames(className, {
          bw_form_control: !isChoiceControl,
          bw_form_control_input: !isChoiceControl,
          bw_form_control_bordered: bordered,
          bw_form_choice_native: isChoiceControl,
          'is-invalid': hasError,
          'is-readonly': readOnly,
          bw_field_error_flash: isFlashing,
        })}
        disabled={disabled}
        readOnly={readOnly}
        aria-invalid={hasError || undefined}
        aria-describedby={describedBy}
        name={props.name || field}
        data-field={props['data-field'] || field}
        {...valueProps}
        {...props}
        onChange={handleChange}
      />
      {error && <ErrorMessage id={errorId} message={errorMessage} />}
    </React.Fragment>
  );
};

FormInput.propTypes = {
  type: PropTypes.string,
  field: PropTypes.string,
  validation: PropTypes.object,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  bordered: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default FormInput;
